import { useEffect, useState } from "react";
import CustomLoader from "../../../components/common/CustomLoader";
import { getCustomDashboardDetails } from "../../../service/ai-model.service";
import constant from "../../../helper/constant";
import images from "../../../helper/images";
import { Link } from "react-router-dom";
import { formatDate } from "../../../helper/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { useAuthContext } from "../../../context/auth.context";

const CustomViewList = () => {
    const [loading, setLoading] = useState(false);
    const [viewList, setViewList] = useState({ zoho: [], custom: [] });
    const { userInfo } = useAuthContext();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const refId = params.get("refId");
        const org = params.get("org");
        setLoading(true);
        getCustomDashboardDetails({ id: refId })
            .then((response) => {
                if (response && response.results.length > 0) {
                    const filteredList = response.results.filter(item => item.org === org);
                    if (filteredList.length > 0) {
                        const list = filteredList[0]?.result["zoho-dashboards"]?.map(d => ({ ...d, workspaceId: filteredList[0].result.workspaceId }));
                        const clist = filteredList[0]?.result["custom-dashboard"]?.map(d => ({ ...d, workspaceId: filteredList[0].result.workspaceId }));
                        setViewList({ zoho: list || [], custom: clist || [] });
                    }
                }
            })
            .finally(() => setLoading(false));
    }, []);

    const renderViewList = (org, list, isCustom) => {
        if (loading) {
            return <p className="text-center p-5">Loading...</p>;
        }
        if (list.length === 0) {
            return <p className="error-msg text-center p-5">No custom views available.</p>;
        }
        return list.map((view, index) => (
            <div className="col-md-12 col-lg-6 col-xl-4 my-3" key={index}>
                <div className="recentmodelbox">
                    <div className="d-flex pl-3 align-items-center border-bottom justify-content-between flex-wrap">
                        <div className="mw-170 py-3">
                            <b>Name : </b> {view.viewName}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-self-center">
                        <img src={images.dashbord2}
                            alt="dashboard" className="dashboard-image py-1"
                            crossOrigin="anonymous" />
                    </div>

                    <div className={`modelupdatebox border-top p-2 d-flex mt-auto ${isCustom ? 'justify-content-end' : 'justify-content-between'} align-items-center flex-wrap
                        `}>
                        {!isCustom && <div className="text-secondary">
                            <div>
                                Created: {formatDate(Number(view.createdTime), constant.dateTimeFormat)}
                            </div>
                            <div>
                                Modified: {formatDate(Number(view.lastModifiedTime), constant.dateTimeFormat)}
                            </div>
                        </div>
                        }
                        <Link
                            to={isCustom ? view.url :
                                `/${constant.PAGES.CUSTOM_DASHBOARD_VIEW}?org=${org}&viewId=${view.viewId}&workspaceId=${view.workspaceId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`border px-3 py-2 btngreen `}
                        >
                            View Detail
                        </Link>
                    </div>
                </div>
            </div>
        ));
    }

    const onCopyCreds = () => {
        navigator.clipboard.writeText(userInfo.org.zohoPass);
    }
    const render = () => {
        const params = new URLSearchParams(window.location.search);
        const org = params.get("org");
        return (
            <>
                {loading && <CustomLoader full />}
                <div className="row mx-0">
                    <div className="col-md-12 px-md-0">
                        <div className="p-5">
                            <h3 className="mb-2">Custom Dashboad - {org}</h3>
                            <div className="row">
                                {renderViewList(org, viewList.custom, true)}
                            </div>
                        </div>
                        <div className="px-5 pt-0 pb-5">
                            <h3 className="mb-2">Zoho Dashboad - {org}</h3>
                            {userInfo.org.zohoPass && <p className="d-flex mb-1">Dashboard Credentials : ********* <Link onClick={() => onCopyCreds()}><FontAwesomeIcon icon={faCopy} /></Link></p>}
                            <div className="row">
                                {renderViewList(org, viewList.zoho)}
                            </div>
                        </div>
                    </div>
                </div>
            </>)
    }
    return render();
};

export default CustomViewList;